import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const createTransactionFromAdjustmentSlice = createSlice({
  name: 'createTransactionFromAdjustmentSlice',
  initialState: {},
  reducers: {
    createTransactionFromBenefitAdjustment(
      _,
      _action: PayloadAction<{ adjustmentId: string | number; claimId: string | number }>,
    ) {},
    createTransactionFromPaymentAdjustment(
      _,
      _action: PayloadAction<{ adjustmentId: string | number; claimId: string | number }>,
    ) {},
  },
});

export const { createTransactionFromBenefitAdjustment, createTransactionFromPaymentAdjustment } =
  createTransactionFromAdjustmentSlice.actions;

export const createTransactionFromAdjustmenReducer = createTransactionFromAdjustmentSlice.reducer;
export const createTransactionFromAdjustmenReducerPath = createTransactionFromAdjustmentSlice.reducerPath;
